var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 817,
    height: 817,
    viewBox: "0 0 817 817",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.8594 519.787C99.6403 519.021 99.585 518.228 99.3935 517.46L99.3105 517.488L99.8594 519.787Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.541 219.093C320.199 41.3741 603.296 76.4627 709.102 284.044C634.607 284.071 517.963 284.016 454.769 284.044C408.955 284.071 379.37 283.003 347.321 299.891C309.663 319.706 281.256 356.465 271.32 399.631L167.541 219.093Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M307.393 433.105C307.393 493.32 356.355 542.34 416.538 542.34C476.72 542.34 525.682 493.348 525.682 433.105C525.682 372.89 476.72 323.868 416.538 323.868C356.355 323.868 307.393 372.862 307.393 433.105Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M458.904 576.06C397.627 594.263 325.948 574.063 286.675 506.294C256.707 454.534 177.504 316.56 141.486 253.799C15.4012 447.063 124.081 710.424 352.962 755.366L458.904 576.06Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M517.937 323.868C568.98 371.328 580.09 448.185 545.525 507.77C519.471 552.659 436.379 692.962 396.094 760.895C631.926 775.431 803.853 544.284 726.181 323.868H517.937Z",
    fill: "#FBBC05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.bad2af3795b6e5664a4bff1925e50f4f.svg";
export { ForwardRef as ReactComponent };